import { FC, useState, useEffect, useRef } from 'react';
import React from 'react';
import OutlinedInputProps from '@mui/material/OutlinedInput';
import { InputText, InputProps, RequiredInputProps } from './InputText';

type NumericInputProps = {
  title?: string;
  inputError?: string;
  placeholder?: string;
  colorTitle?: string;
  errorWithoutText?: boolean;
  inputRef?: React.RefObject<HTMLInputElement | null> | null;
  value: number | undefined | null;
  onChange: (val: number | undefined) => void;
  restProps?: object;
};

export const NumericInput: FC<NumericInputProps> = ({
  value,
  onChange,
  title,
  placeholder,
  inputError,
  colorTitle,
  errorWithoutText,
  inputRef,
  restProps
}) => {
  const [localValue, setLocalValue] = useState(
    value !== undefined && value !== null ? String(value) : ''
  );
  const isFocused = useRef(false);

  useEffect(() => {
    if (isFocused.current) return;
    const incoming = value !== undefined && value !== null ? String(value) : '';
    setLocalValue(incoming);
  }, [value]);

  return (
    <InputText
      title={title}
      placeholder={placeholder}
      inputError={inputError}
      colorTitle={colorTitle}
      errorWithoutText={errorWithoutText}
      inputRef={inputRef}
      inputProps={{
        ...restProps,
        value: localValue,
        type: 'text',
        onFocus: () => {
          isFocused.current = true;
        },
        onBlur: () => {
          isFocused.current = false;
        },
        onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === '-') e.preventDefault();
        },
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          const raw = e.target.value;
          if (/^\d*$/.test(raw)) {
            setLocalValue(raw);
            onChange(raw === '' ? undefined : Number(raw));
          }
        }
      }}
    />
  );
};
